

import React, { useEffect, useState, useMemo } from "react";
import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { __jobStatus, __jobStatusDisplay } from '../../constants';

function SelectBox({ state, setState }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleShow = (obj) => {
    setState((prevState) => ({ ...prevState, showData: obj }));
    handleClose();
  };

  

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size="small"
        sx={{ m: 0, p: 0, minWidth: "unset" }}
      >
        <MoreHorizIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        {state.list.map((obj, index) => (
          <MenuItem key={index} onClick={() => handleShow(obj)}>
            {obj.statusDisplay}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

const JobsCard = ({ jobsBooking, type }) => {
  const [state, setState] = useState({ list: [], showData: {} });

  useEffect(() => {
    const STATUSES = Object.values(__jobStatus);

    const filteredData = jobsBooking.filter((item) => item.type === type);

    const list = STATUSES.map((status) => {
      const existingItem = filteredData.find((obj) => obj.status === status);
      return existingItem
        ? { ...existingItem, statusDisplay: __jobStatusDisplay[status] || status.toString() }
        : {
            lastMonth: 0,
            total: 0,
            type,
            status,
            statusDisplay: __jobStatusDisplay[status] || status.toString(),
          };
    });

    setState((prevState) => ({ ...prevState, list, showData: list[0] || {} }));
  }, [jobsBooking, type]);

  const percentage = useMemo(
    () => (total, lastMonth) =>
      parseFloat(((total - lastMonth) * 100) / (lastMonth !== 0 ? lastMonth : 1)).toFixed(1),
    []
  );

  return (
    <Container className="card">
      <Header>
        <div>
          {type}
          <br />
          <small>{state?.showData?.statusDisplay}</small>
        </div>
        {state.list.length > 0 && <SelectBox state={state} setState={setState} />}
      </Header>
      <Body>
        <strong>{state?.showData?.total}</strong>
        {(percentage(state?.showData?.total, state?.showData?.lastMonth) ||
          percentage(state?.showData?.total, state?.showData?.lastMonth) === 0) && (
          <small
            className={
              percentage(state?.showData?.total, state?.showData?.lastMonth) >= 0 ? "green" : "red"
            }
          >
            {percentage(state?.showData?.total, state?.showData?.lastMonth)}%{" "}
            <span>since last month</span>
          </small>
        )}
      </Body>
    </Container>
  );
};

const Container = styled("div")`
    min-width: 240px;
    border-radius: 8px;
    box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
`;

const Header = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.7rem 1rem;
    font-weight: 600;
    font-size: 80%;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    display: grid;
    padding: 0.9rem 1rem;
    padding-bottom: 1rem;
    small{
        font-size: 70%;
        span{
            margin-left: 0.3rem;
        }
    }
`;

export default JobsCard